import { useEffect } from 'react';
import { SmartLaunchHandler, LAUNCH } from 'smarterfhir';
const callbackUrl = `/fhir/callback`;

const FHIRWebLaunch = () => {
  const handleWebLaunch = async () => {
    try {
      let emrClientID;
      let emrClientSecret;
      emrClientID = import.meta.env.VITE_ATHENA_EMR_CLIENT_ID;
      emrClientSecret = import.meta.env.VITE_ATHENA_EMR_CLIENT_SECRET;

      const smartLaunchHandler = new SmartLaunchHandler(
        emrClientID,
        emrClientSecret
      );
      smartLaunchHandler.authorizeEMR(LAUNCH.EMR, callbackUrl);
    } catch (e) {
      if (e instanceof Error) {
        throw e;
      }
      throw new Error(`Unknown Error: ${e}`);
    }
  };
  useEffect(() => {
    handleWebLaunch();
  }, []);

  return <></>;
};

export default FHIRWebLaunch;
